/* eslint-env browser */

const infoToggle = function (e = window.event) { // eslint-disable-line no-unused-vars
  const target = e.target.parentNode.parentNode

  const card = target.querySelector('.info-card')
  fastdom.mutate(() => {
    card.classList.toggle('--ativo')
  })
}
